module.exports = __webpack_public_path__ + "img/AcgDfAAH.50f6a642.svg";